import TaxonomyTabs from './taxonomy-tabs';

export default TaxonomyTabs;